<script setup lang="ts">
import CompanyFilter from '@/components/filters/CompanyFilter.vue'
import PriorityFilter from '@/components/filters/PriorityFilter.vue'
import DateFilter from '@/components/filters/DateFilter.vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/useUserStore'
import { useOpportunityStore } from '@/stores/useOpportunityStore'
import CommercialFilter from '@/components/filters/CommercialFilter.vue'
import DateDeadLineFilter from '@/components/filters/DateDeadLineFilter.vue'
import { UserRole } from '@/utils/enums'

const userStore = useUserStore()
const { role } = storeToRefs(userStore)

const opportunityStore = useOpportunityStore()
const { filters } = storeToRefs(opportunityStore)
</script>

<template>
  <div class="flex flex-row gap-4 w-full mb-2">
    <div class="w-auto">
      <label class="form-control w-full" for="opportunity-deadline">
        <div class="label">
          <span class="label-text font-semibold">Par Mois/Année</span>
        </div>
        <DateFilter v-model="filters.selectedDate" class="w-full" />
      </label>
      <DateDeadLineFilter v-model="filters.isCheckedDateDeadLine" label="Date signature dépassée" />
    </div>
    <div class="w-auto">
      <CompanyFilter
        v-model="filters.selectedCompany"
        :unique-companies="filters.companies"
        label="Par Portefeuille"
      />
    </div>
    <div class="w-auto">
      <PriorityFilter v-model="filters.selectedPriority" label="Par Forecast  ⭐⭐⭐" />
    </div>
    <div v-if="role === UserRole.Manager" class="w-72 shrink-0">
      <CommercialFilter v-model="filters.selectedCommercials" label="Par Commercial" />
    </div>
  </div>
</template>
